const Loading = () => {
  return (
    <div className="d-flex justify-content-center">
      <output
        className="spinner-border"
        aria-label="Loading"
        style={{ width: "5rem", height: "5rem" }}></output>
    </div>
  );
};

export default Loading;
